import { RecordMask } from '@skinsoft/types'

/* tslint:disable:object-literal-sort-keys */
// tslint:disable-next-line:variable-name
export const wemi_metaRecordMask: RecordMask = {
    name: {
        translatedString: {
            de: 'Saisie objet',
            en: 'Saisie objet',
            it: 'Saisie objet',
            fr: 'Saisie objet',
            es: 'Saisie objet',
            nl: 'Saisie objet',
            'fr-ca': 'Saisie objet',
        },
        translatedId: null,
    },
    categories: [
        {
            label: null,
            maskFields: [
                {
                    entityField: {
                        entityFieldId: '5c50161dca5d4700015b3c94',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'identificationItemSchema',
                        name: 'identifiers',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'Identifier',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.item.commonsitemschema.identificationitemschema.complex.Identifier',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5c50161dca5d4700015b3c92',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'identificationItemSchema',
                                name: 'identifier',
                                mandatorySystem: false,
                                type: {
                                    type: 'String',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'identificationItemSchema.identifiers.identifier',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5c50161dca5d4700015b3c93',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'identificationItemSchema',
                                name: 'idType',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'identificationItemSchema.identifiers.idType',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'identificationItemSchema.identifiers',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5c50161dca5d4700015b3c92',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'identificationItemSchema',
                                name: 'identifier',
                                mandatorySystem: false,
                                type: {
                                    type: 'String',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'identificationItemSchema.identifiers.identifier',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field-identifier',
                        },
                        {
                            entityField: {
                                entityFieldId: '5c50161dca5d4700015b3c93',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'identificationItemSchema',
                                name: 'idType',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'identificationItemSchema.identifiers.idType',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field-id-type',
                        },
                    ],
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: null,
                    columnDisplay: true,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field-identifiers',
                },
                {
                    entityField: {
                        entityFieldId: '5b9fb471190494000112feea',
                        entity: 'physicalMuseumManifestation',
                        abstractEntity: 'museumManifestation',
                        schema: 'descriptionSchema',
                        name: 'otherDesignations',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'OtherDesignation',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.OtherDesignation',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5b9fb471190494000112fee7',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'type',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.otherDesignations.type',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5b9fb471190494000112fee8',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'designation',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.otherDesignations.designation',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'descriptionSchema.otherDesignations',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5b9fb471190494000112fee8',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'designation',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.otherDesignations.designation',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--other-identifiers--identifier',
                        },
                        {
                            entityField: {
                                entityFieldId: '5b9fb471190494000112fee7',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'type',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.otherDesignations.type',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--other-identifiers--id-type',
                        },
                    ],
                    mandatoryUser: false,
                    order: 1,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--other-identifiers',
                },
                {
                    entityField: {
                        entityFieldId: '5b9fb471190494000112fedb',
                        entity: 'physicalMuseumManifestation',
                        abstractEntity: 'museumManifestation',
                        schema: 'descriptionSchema',
                        name: 'domain',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'ThesaurusTerm',
                                thesaurusIdentifier: 'domain',
                                referenceField: true,
                            },
                            listClass: null,
                            referenceField: true,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [],
                        path: 'descriptionSchema.domain',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                    },
                    fieldFormat: {
                        id: '59bcaba79056baee21ac79ff',
                        name: 'hierarchical-component',
                        defaultFormat: true,
                    },
                    inputComponent: {
                        id: '595ca2a7857aaa0001ac29de',
                        name: 'reference-input-component',
                        defaultComponent: true,
                    },
                    formatter: null,
                    children: null,
                    mandatoryUser: false,
                    order: 2,
                    tableDisplay: null,
                    columnDisplay: true,
                    paginated: null,
                    applyAutomaticFormat: false,
					dataCy: 'item-mask-field-domain',
                },
                {
                    entityField: {
                        entityFieldId: '5d4c49020de7d241b997e372',
                        entity: 'physicalMuseumManifestation',
                        abstractEntity: 'museumManifestation',
                        schema: 'descriptionSchema',
                        name: 'denominations',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'Denomination',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.Denomination',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5d4c49020de7d241b997e36f',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'denomination',
                                mandatorySystem: false,
                                type: {
                                    type: 'ThesaurusTerm',
                                    thesaurusIdentifier: 'denomination',
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.denominations.denomination',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5d4c49020de7d241b997e371',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.denominations.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'descriptionSchema.denominations',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5d4c49020de7d241b997e36f',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'denomination',
                                mandatorySystem: false,
                                type: {
                                    type: 'ThesaurusTerm',
                                    thesaurusIdentifier: 'denomination',
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.denominations.denomination',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '59bcaba79056baee21ac79ff',
                                name: 'hierarchical-component',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--denomination',
                        },
                        {
                            entityField: {
                                entityFieldId: '5d4c49020de7d241b997e371',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.denominations.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--denomination-precision',
                        },
                    ],
                    mandatoryUser: false,
                    order: 3,
                    tableDisplay: null,
                    columnDisplay: true,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--denominations',
                },
                {
                    entityField: {
                        entityFieldId: '611fbac1dbd31457d95d86f6',
                        entity: 'museumWork',
                        abstractEntity: 'work',
                        schema: 'descriptionMuseumWorkSchema',
                        name: 'workTitles',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'WorkTitle',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.work.commonworkschema.identificationschema.complex.WorkTitle',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '611fbac1dbd31457d95d86ee',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionMuseumWorkSchema',
                                name: 'title',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionMuseumWorkSchema.workTitles.title',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '611fbac1dbd31457d95d86f1',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionMuseumWorkSchema',
                                name: 'typeOfTitle',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionMuseumWorkSchema.workTitles.typeOfTitle',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'descriptionMuseumWorkSchema.workTitles',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                        dataCy: 'item-mask-field--titles',
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '611fbac1dbd31457d95d86ee',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionMuseumWorkSchema',
                                name: 'title',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionMuseumWorkSchema.workTitles.title',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--title',
                        },
                        {
                            entityField: {
                                entityFieldId: '611fbac1dbd31457d95d86f1',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionMuseumWorkSchema',
                                name: 'typeOfTitle',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionMuseumWorkSchema.workTitles.typeOfTitle',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--titleType',
                        },
                    ],
                    mandatoryUser: false,
                    order: 4,
                    tableDisplay: null,
                    columnDisplay: true,
                    paginated: null,
                    applyAutomaticFormat: false,
                },
                {
                    entityField: {
                        entityFieldId: '5b9fb469190494000112d00d',
                        entity: 'museumWork',
                        abstractEntity: 'work',
                        schema: 'descriptionWorkSchema',
                        name: 'credits',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'Credit',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.Credit',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5d4c49000de7d241b997e129',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'creatorAuthorDirectors',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'CreatorAuthorDirector',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.CreatorAuthorDirector',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e126',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'alias',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'Alias',
                                            subTypes: [],
                                            filter: '595ca6a7857ababbc1abcd16',
                                            isRestrictive: false,
                                            esPath: 'aliasSchema.tags.ref',
                                            trueType: 'Alias',
                                            useTrueType: false,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.alias',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e127',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'function',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'function',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.function',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionWorkSchema.credits.creatorAuthorDirectors',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5d4c49000de7d241b997e12d',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'creationDates',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'WorkCreationDate',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.WorkCreationDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12a',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'date',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'SkinDate',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionWorkSchema.credits.creationDates.date',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: false,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12b',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'qualifierDate',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'qualifierDate',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationDates.qualifierDate',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionWorkSchema.credits.creationDates',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5d4c49000de7d241b997e131',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'creationPlaces',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'CreationPlace',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.CreationPlace',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12e',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'place',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'location',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionWorkSchema.credits.creationPlaces.place',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12f',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'placeQualifier',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'placeQualifiers',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationPlaces.placeQualifier',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionWorkSchema.credits.creationPlaces',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5df0f312a58aaf32591c16d3',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'notes',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'TranslatedString',
                                        referenceField: false,
                                    },
                                    listClass: null,
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionWorkSchema.credits.notes',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5b9fb469190494000112d00b',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionWorkSchema.credits.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'descriptionWorkSchema.credits',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5d4c49000de7d241b997e129',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'creatorAuthorDirectors',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'CreatorAuthorDirector',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.CreatorAuthorDirector',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e126',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'alias',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'Alias',
                                            subTypes: [],
                                            filter: '595ca6a7857ababbc1abcd16',
                                            isRestrictive: false,
                                            esPath: 'aliasSchema.tags.ref',
                                            trueType: 'Alias',
                                            useTrueType: false,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.alias',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e127',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'function',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'function',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.function',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e128',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'qualifier',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'authorQualifier',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.qualifier',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5fbce5c0579e530006d9c498',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'TranslatedString',
                                                referenceField: false,
                                            },
                                            listClass: null,
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionWorkSchema.credits.creatorAuthorDirectors',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: null,
                                name: null,
                                defaultFormat: null,
                            },
                            inputComponent: {
                                id: null,
                                name: null,
                                defaultComponent: null,
                            },
                            formatter: null,
                            children: [
                                {
                                    entityField: {
                                        entityFieldId: '5d4c49000de7d241b997e126',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'alias',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'Alias',
                                            subTypes: [],
                                            filter: '595ca6a7857ababbc1abcd16',
                                            isRestrictive: false,
                                            esPath: 'aliasSchema.tags.ref',
                                            trueType: 'Alias',
                                            useTrueType: false,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.alias',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '591ca0a7907aba0001ac69fe',
                                        name: 'reference-title',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creator-author-director',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5d4c49000de7d241b997e127',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'function',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'function',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.function',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 1,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creator-author-directors--function'
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5fbce5c0579e530006d9c498',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'TranslatedString',
                                                referenceField: false,
                                            },
                                            listClass: null,
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creatorAuthorDirectors.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 2,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creator-author-directors--precision'
                                },
                            ],
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--creator-author-directors',
                        },
                        {
                            entityField: {
                                entityFieldId: '5d4c49000de7d241b997e12d',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'creationDates',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'WorkCreationDate',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.WorkCreationDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12a',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'date',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'SkinDate',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionWorkSchema.credits.creationDates.date',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: false,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12b',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'qualifierDate',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'qualifierDate',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationDates.qualifierDate',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12c',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationDates.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionWorkSchema.credits.creationDates',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: null,
                                name: null,
                                defaultFormat: null,
                            },
                            inputComponent: {
                                id: null,
                                name: null,
                                defaultComponent: null,
                            },
                            formatter: null,
                            children: [
                                {
                                    entityField: {
                                        entityFieldId: '5d4c49000de7d241b997e12a',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'date',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'SkinDate',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionWorkSchema.credits.creationDates.date',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: false,
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7857aa45301ac79df',
                                        name: 'date-fiaf-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac79df',
                                        name: 'date-fiaf-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creation-date',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5d4c49000de7d241b997e12b',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'qualifierDate',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'qualifierDate',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationDates.qualifierDate',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 1,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creation-dates--qualifier',
                                },
                            ],
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--creation-dates'
                        },
                        {
                            entityField: {
                                entityFieldId: '5d4c49000de7d241b997e131',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'creationPlaces',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'CreationPlace',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.work.commonworkschema.descriptionschema.complex.CreationPlace',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12e',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'place',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'location',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionWorkSchema.credits.creationPlaces.place',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e12f',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'placeQualifier',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'placeQualifiers',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationPlaces.placeQualifier',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5d4c49000de7d241b997e130',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationPlaces.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionWorkSchema.credits.creationPlaces',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: null,
                                name: null,
                                defaultFormat: null,
                            },
                            inputComponent: {
                                id: null,
                                name: null,
                                defaultComponent: null,
                            },
                            formatter: null,
                            children: [
                                {
                                    entityField: {
                                        entityFieldId: '5d4c49000de7d241b997e12e',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'place',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'location',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionWorkSchema.credits.creationPlaces.place',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creation-place',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5d4c49000de7d241b997e12f',
                                        entity: 'museumWork',
                                        abstractEntity: 'work',
                                        schema: 'descriptionWorkSchema',
                                        name: 'placeQualifier',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'placeQualifiers',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionWorkSchema.credits.creationPlaces.placeQualifier',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 1,
                                    tableDisplay: null,
                                    columnDisplay: true,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--creation-place--qualifier',
                                },
                            ],
                            mandatoryUser: false,
                            order: 2,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--creation-places',
                        },
                        {
                            entityField: {
                                entityFieldId: '5b9fb469190494000112d00b',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionWorkSchema.credits.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 3,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--credits--precision',
                        },
                        {
                            entityField: {
                                entityFieldId: '5df0f312a58aaf32591c16d3',
                                entity: 'museumWork',
                                abstractEntity: 'work',
                                schema: 'descriptionWorkSchema',
                                name: 'notes',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'TranslatedString',
                                        referenceField: false,
                                    },
                                    listClass: null,
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionWorkSchema.credits.notes',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 4,
                            tableDisplay: null,
                            columnDisplay: true,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--credits--notes',
                        },
                    ],
                    mandatoryUser: false,
                    order: 5,
                    tableDisplay: null,
                    columnDisplay: true,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--credits',
                },
                {
                    entityField: {
                        entityFieldId: '5b9fb471190494000112ff0c',
                        entity: 'physicalMuseumManifestation',
                        abstractEntity: 'museumManifestation',
                        schema: 'descriptionSchema',
                        name: 'materialAndTechniques',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'MaterialTechnique',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.materialtechnique.MaterialTechnique',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5b9fb471190494000112ff07',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'materials',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'Material',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.materialtechnique.Material',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5b9fb471190494000112ff04',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'material',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'material',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.material',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff05',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'color',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'color',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.color',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff06',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionSchema.materialAndTechniques.materials',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5b9fb471190494000112ff0a',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'techniques',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'Technique',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.materialtechnique.Technique',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5b9fb471190494000112ff08',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'technique',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'technique',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.techniques.technique',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff09',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.techniques.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionSchema.materialAndTechniques.techniques',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5b9fb471190494000112ff0b',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.materialAndTechniques.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5fbce5a9579e530006d9c2c5',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'notes',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'TranslatedString',
                                        referenceField: false,
                                    },
                                    listClass: null,
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.materialAndTechniques.notes',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'descriptionSchema.materialAndTechniques',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5b9fb471190494000112ff07',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'materials',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'Material',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.materialtechnique.Material',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5b9fb471190494000112ff04',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'material',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'material',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.material',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff05',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'color',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'color',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.color',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff06',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '602f9ea20f7e4253a65b7bf5',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'provider',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'Alias',
                                                subTypes: [],
                                                filter: '595ca6a7857ababbc1abcd1e',
                                                isRestrictive: false,
                                                esPath: 'aliasSchema.tags.ref',
                                                trueType: 'Alias>',
                                                useTrueType: false,
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.provider',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionSchema.materialAndTechniques.materials',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: null,
                                name: null,
                                defaultFormat: null,
                            },
                            inputComponent: {
                                id: null,
                                name: null,
                                defaultComponent: null,
                            },
                            formatter: null,
                            children: [
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff04',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'material',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'material',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.material',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--material',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff05',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'color',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'List',
                                            entityFieldType: {
                                                type: 'ThesaurusTerm',
                                                thesaurusIdentifier: 'color',
                                                referenceField: true,
                                            },
                                            listClass: null,
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.color',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 1,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--materials--colors',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff06',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.materials.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 2,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--materials--precision',
                                },
                            ],
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--materials',
                        },
                        {
                            entityField: {
                                entityFieldId: '5b9fb471190494000112ff0a',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'techniques',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'Technique',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.materialtechnique.Technique',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5b9fb471190494000112ff08',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'technique',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'technique',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.techniques.technique',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff09',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.techniques.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionSchema.materialAndTechniques.techniques',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: null,
                                name: null,
                                defaultFormat: null,
                            },
                            inputComponent: {
                                id: null,
                                name: null,
                                defaultComponent: null,
                            },
                            formatter: null,
                            children: [
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff08',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'technique',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'technique',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.techniques.technique',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--technique',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff09',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.materialAndTechniques.techniques.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 1,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--techniques--precision',
                                },
                            ],
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--techniques',
                        },
                        {
                            entityField: {
                                entityFieldId: '5b9fb471190494000112ff0b',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.materialAndTechniques.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 2,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--material-and-techniques--precision',
                        },
                        {
                            entityField: {
                                entityFieldId: '5fbce5a9579e530006d9c2c5',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'notes',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'TranslatedString',
                                        referenceField: false,
                                    },
                                    listClass: null,
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.materialAndTechniques.notes',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 3,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--material-and-techniques--notes',
                        },
                    ],
                    mandatoryUser: false,
                    order: 7,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--material-and-techniques',
                },
                {
                    entityField: {
                        entityFieldId: '5b9fb471190494000112ff1b',
                        entity: 'physicalMuseumManifestation',
                        abstractEntity: 'museumManifestation',
                        schema: 'descriptionSchema',
                        name: 'measurements',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'Measurement',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.measurement.Measurement',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5b9fb471190494000112ff1a',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'measures',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'Measure',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.measurement.Measure',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5ecd1d79e639b1502db7832f',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'typeOfMeasure',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'typeOfMeasure',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.measurements.measures.typeOfMeasure',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff18',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'value',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.value',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff19',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'unit',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'unitOfMeasure',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.unit',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5fbce5aa579e530006d9c2c6',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionSchema.measurements.measures',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5bbc91a230c49e0001c12d06',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.measurements.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5df0f30da58aaf32591c15d7',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'notes',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'TranslatedString',
                                        referenceField: false,
                                    },
                                    listClass: null,
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.measurements.notes',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'descriptionSchema.measurements',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5b9fb471190494000112ff1a',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'measures',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'Measure',
                                        referenceField: false,
                                    },
                                    listClass:
                                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.descriptionmanifestationschema.complex.measurement.Measure',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [
                                    {
                                        entityFieldId: '5ecd1d79e639b1502db7832f',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'typeOfMeasure',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'typeOfMeasure',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.measurements.measures.typeOfMeasure',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff18',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'value',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.value',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5b9fb471190494000112ff19',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'unit',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'unitOfMeasure',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.unit',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    {
                                        entityFieldId: '5fbce5aa579e530006d9c2c6',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'precision',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.precision',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                ],
                                path: 'descriptionSchema.measurements.measures',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: null,
                                name: null,
                                defaultFormat: null,
                            },
                            inputComponent: {
                                id: null,
                                name: null,
                                defaultComponent: null,
                            },
                            formatter: null,
                            children: [
                                {
                                    entityField: {
                                        entityFieldId: '5ecd1d79e639b1502db7832f',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'typeOfMeasure',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'typeOfMeasure',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path:
                                            'descriptionSchema.measurements.measures.typeOfMeasure',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--measures--type-of-measures',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff18',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'value',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'TranslatedString',
                                            referenceField: false,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.value',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '595ca6a7907aba0001ac69fe',
                                        name: 'text',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca6a7857aaa0001ac68db',
                                        name: 'text-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 1,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--measures--value',
                                },
                                {
                                    entityField: {
                                        entityFieldId: '5b9fb471190494000112ff19',
                                        entity: 'physicalMuseumManifestation',
                                        abstractEntity: 'museumManifestation',
                                        schema: 'descriptionSchema',
                                        name: 'unit',
                                        mandatorySystem: false,
                                        type: {
                                            type: 'ThesaurusTerm',
                                            thesaurusIdentifier: 'unitOfMeasure',
                                            referenceField: true,
                                        },
                                        isReadOnly: false,
                                        isComputed: false,
                                        entityFields: [],
                                        path: 'descriptionSchema.measurements.measures.unit',
                                        tableDisplay: null,
                                        columnDisplay: null,
                                        isChildren: true,
                                        dependOnFieldParameter: null,
                                        needId: false,
                                        readOnlyValues: null,
                                        usableForFacets: true,
                                    },
                                    fieldFormat: {
                                        id: '59bcaba79056baee21ac79ff',
                                        name: 'hierarchical-component',
                                        defaultFormat: true,
                                    },
                                    inputComponent: {
                                        id: '595ca2a7857aaa0001ac29de',
                                        name: 'reference-input-component',
                                        defaultComponent: true,
                                    },
                                    formatter: null,
                                    children: null,
                                    mandatoryUser: false,
                                    order: 2,
                                    tableDisplay: null,
                                    columnDisplay: null,
                                    paginated: null,
                                    applyAutomaticFormat: false,
                                    dataCy: 'item-mask-field--measures--unit',
                                },
                            ],
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--measures',
                        },
                        {
                            entityField: {
                                entityFieldId: '5bbc91a230c49e0001c12d06',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.measurements.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--measurements--precision',
                        },
                        {
                            entityField: {
                                entityFieldId: '5df0f30da58aaf32591c15d7',
                                entity: 'physicalMuseumManifestation',
                                abstractEntity: 'museumManifestation',
                                schema: 'descriptionSchema',
                                name: 'notes',
                                mandatorySystem: false,
                                type: {
                                    type: 'List',
                                    entityFieldType: {
                                        type: 'TranslatedString',
                                        referenceField: false,
                                    },
                                    listClass: null,
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'descriptionSchema.measurements.notes',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 2,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--measurements--notes',
                        },
                    ],
                    mandatoryUser: false,
                    order: 8,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--measurements',
                },
                {
                    entityField: {
                        entityFieldId: '5db2fec07ea2523ac3c762a9',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'stateItemSchema',
                        name: 'currentItemState',
                        mandatorySystem: false,
                        type: {
                            type: 'CurrentItemState',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5db2fec07ea2523ac3c762a7',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'stateItemSchema',
                                name: 'currentState',
                                mandatorySystem: false,
                                type: {
                                    type: 'ThesaurusTerm',
                                    thesaurusIdentifier: 'stateOfConservation',
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'stateItemSchema.currentItemState.currentState',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5fbce5b7579e530006d9c393',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'stateItemSchema',
                                name: 'date',
                                mandatorySystem: false,
                                type: {
                                    type: 'String',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'stateItemSchema.currentItemState.date',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            {
                                entityFieldId: '5db2fec07ea2523ac3c762a8',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'stateItemSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'stateItemSchema.currentItemState.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'stateItemSchema.currentItemState',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5db2fec07ea2523ac3c762a7',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'stateItemSchema',
                                name: 'currentState',
                                mandatorySystem: false,
                                type: {
                                    type: 'ThesaurusTerm',
                                    thesaurusIdentifier: 'stateOfConservation',
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'stateItemSchema.currentItemState.currentState',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '59bcaba79056baee21ac79ff',
                                name: 'hierarchical-component',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                        {
                            entityField: {
                                entityFieldId: '6329a93117cb442ba7d7b005',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'stateItemSchema',
                                name: 'dateHistory',
                                mandatorySystem: false,
                                type: {
                                    type: 'SkinDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'stateItemSchema.currentItemState.dateHistory',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                        {
                            entityField: {
                                entityFieldId: '5db2fec07ea2523ac3c762a8',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'stateItemSchema',
                                name: 'precision',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'stateItemSchema.currentItemState.precision',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 2,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                    ],
                    mandatoryUser: false,
                    order: 9,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                },
                {
                    entityField: {
                        entityFieldId: '5baccdc870aa490001801e13',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'locationItemSchema',
                        name: 'permanentLocation',
                        mandatorySystem: false,
                        type: {
                            type: 'PermanentLocation',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5baccdc870aa490001801e10',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'effectiveDate',
                                mandatorySystem: false,
                                type: {
                                    type: 'SkinDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.permanentLocation.effectiveDate',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5baccdc870aa490001801e11',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'permanentLocation',
                                mandatorySystem: false,
                                type: {
                                    type: 'Location',
                                    subTypes: [],
                                    filter: null,
                                    isRestrictive: null,
                                    esPath: null,
                                    trueType: 'Location',
                                    useTrueType: false,
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.permanentLocation.permanentLocation',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'locationItemSchema.permanentLocation',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5baccdc870aa490001801e11',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'permanentLocation',
                                mandatorySystem: false,
                                type: {
                                    type: 'Location',
                                    subTypes: [],
                                    filter: null,
                                    isRestrictive: null,
                                    esPath: null,
                                    trueType: 'Location',
                                    useTrueType: false,
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.permanentLocation.permanentLocation',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '59bcaba79056baee21ac79ff',
                                name: 'hierarchical-component',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                        {
                            entityField: {
                                entityFieldId: '5baccdc870aa490001801e10',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'effectiveDate',
                                mandatorySystem: false,
                                type: {
                                    type: 'SkinDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.permanentLocation.effectiveDate',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: '595ca6a7857aa45301ac79df',
                                name: 'date-fiaf-component',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac79df',
                                name: 'date-fiaf-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                    ],
                    mandatoryUser: false,
                    order: 10,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                },
                {
                    entityField: {
                        entityFieldId: '5baccdc870aa490001801e1d',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'locationItemSchema',
                        name: 'realTimeLocation',
                        mandatorySystem: false,
                        type: {
                            type: 'RealTimeLocation',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5baccdc870aa490001801e1a',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'effectiveDate',
                                mandatorySystem: false,
                                type: {
                                    type: 'SkinDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.realTimeLocation.effectiveDate',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            {
                                entityFieldId: '5baccdc870aa490001801e1b',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'realTimeLocation',
                                mandatorySystem: false,
                                type: {
                                    type: 'Location',
                                    subTypes: [],
                                    filter: null,
                                    isRestrictive: null,
                                    esPath: null,
                                    trueType: 'Location',
                                    useTrueType: false,
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.realTimeLocation.realTimeLocation',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'locationItemSchema.realTimeLocation',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5baccdc870aa490001801e1b',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'realTimeLocation',
                                mandatorySystem: false,
                                type: {
                                    type: 'Location',
                                    subTypes: [],
                                    filter: null,
                                    isRestrictive: null,
                                    esPath: null,
                                    trueType: 'Location',
                                    useTrueType: false,
                                    referenceField: true,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.realTimeLocation.realTimeLocation',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '59bcaba79056baee21ac79ff',
                                name: 'hierarchical-component',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                        {
                            entityField: {
                                entityFieldId: '5baccdc870aa490001801e1a',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'locationItemSchema',
                                name: 'effectiveDate',
                                mandatorySystem: false,
                                type: {
                                    type: 'SkinDate',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'locationItemSchema.realTimeLocation.effectiveDate',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: false,
                            },
                            fieldFormat: {
                                id: '595ca6a7857aa45301ac79df',
                                name: 'date-fiaf-component',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac79df',
                                name: 'date-fiaf-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 1,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                        },
                    ],
                    mandatoryUser: false,
                    order: 11,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                },
                {
                    entityField: {
                        entityFieldId: '5df0f310a58aaf32591c165e',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'contextualNotesSchema',
                        name: 'notesOnIdentification',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'NoteOnIdentification',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.item.commonsitemschema.contextualNotesSchema.complex.NoteOnIdentification',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5df0f310a58aaf32591c165c',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'contextualNotesSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'contextualNotesSchema.notesOnIdentification.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'contextualNotesSchema.notesOnIdentification',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5df0f310a58aaf32591c165c',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'contextualNotesSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'contextualNotesSchema.notesOnIdentification.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--identification-note',
                        },
                    ],
                    mandatoryUser: false,
                    order: 12,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--identification-notes',
                },
                {
                    entityField: {
                        entityFieldId: '5df0f310a58aaf32591c1667',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'contextualNotesSchema',
                        name: 'notesOnLocationsAndMovements',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'NoteOnLocationsAndMovements',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.item.commonsitemschema.contextualNotesSchema.complex.NoteOnLocationsAndMovements',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5df0f310a58aaf32591c1665',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'contextualNotesSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'contextualNotesSchema.notesOnLocationsAndMovements.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'contextualNotesSchema.notesOnLocationsAndMovements',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5df0f310a58aaf32591c1665',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'contextualNotesSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'contextualNotesSchema.notesOnLocationsAndMovements.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--location-and-movements-note',
                        },
                    ],
                    mandatoryUser: false,
                    order: 13,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--location-and-movements-notes',
                },
                {
                    entityField: {
                        entityFieldId: '60cc5e7729fa931ec035bc67',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'conservationItemSchema',
                        name: 'conservationNotes',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'ConservationNote',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.item.commonsitemschema.conservationitemschema.complex.ConservationNote',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '60cc5e7729fa931ec035bc66',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'conservationItemSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'conservationItemSchema.conservationNotes.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'conservationItemSchema.conservationNotes',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '60cc5e7729fa931ec035bc66',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'conservationItemSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'conservationItemSchema.conservationNotes.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--conservation-note',
                        },
                    ],
                    mandatoryUser: false,
                    order: 14,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--conservation-notes',
                },
                {
                    entityField: {
                        entityFieldId: '5f2aaecc2a93e96e9c185de2',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'safetyPlanSchema',
                        name: 'notes',
                        mandatorySystem: false,
                        type: {
                            type: 'List',
                            entityFieldType: {
                                type: 'SafetyPlanNote',
                                referenceField: false,
                            },
                            listClass:
                                'org.skinsoft.backend.schemas.item.patrimonialitemschema.complex.SafetyPlanNote',
                            referenceField: false,
                        },
                        isReadOnly: false,
                        isComputed: false,
                        entityFields: [
                            {
                                entityFieldId: '5f2aaecc2a93e96e9c185de1',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'safetyPlanSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'safetyPlanSchema.notes.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                        ],
                        path: 'safetyPlanSchema.notes',
                        tableDisplay: null,
                        columnDisplay: null,
                        isChildren: false,
                        dependOnFieldParameter: null,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: false,
                    },
                    fieldFormat: {
                        id: null,
                        name: null,
                        defaultFormat: null,
                    },
                    inputComponent: {
                        id: null,
                        name: null,
                        defaultComponent: null,
                    },
                    formatter: null,
                    children: [
                        {
                            entityField: {
                                entityFieldId: '5f2aaecc2a93e96e9c185de1',
                                entity: 'physicalMuseumItem',
                                abstractEntity: 'museumItem',
                                schema: 'safetyPlanSchema',
                                name: 'note',
                                mandatorySystem: false,
                                type: {
                                    type: 'TranslatedString',
                                    referenceField: false,
                                },
                                isReadOnly: false,
                                isComputed: false,
                                entityFields: [],
                                path: 'safetyPlanSchema.notes.note',
                                tableDisplay: null,
                                columnDisplay: null,
                                isChildren: true,
                                dependOnFieldParameter: null,
                                needId: false,
                                readOnlyValues: null,
                                usableForFacets: true,
                            },
                            fieldFormat: {
                                id: '595ca6a7907aba0001ac69fe',
                                name: 'text',
                                defaultFormat: true,
                            },
                            inputComponent: {
                                id: '595ca6a7857aaa0001ac68db',
                                name: 'text-component',
                                defaultComponent: true,
                            },
                            formatter: null,
                            children: null,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: null,
                            columnDisplay: null,
                            paginated: null,
                            applyAutomaticFormat: false,
                            dataCy: 'item-mask-field--safety-plan-schema-note',
                        },
                    ],
                    mandatoryUser: false,
                    order: 15,
                    tableDisplay: null,
                    columnDisplay: null,
                    paginated: null,
                    applyAutomaticFormat: false,
                    dataCy: 'item-mask-field--safety-plan-schema-notes',
                },
            ],
        },
    ],
    level: 'systemLevel',
    userId: '595ca6a7857aba0001a00001',
    isInputMask: true,
    categoriesDisplay: null,
    target: {
        entityName: 'physicalMuseumItem',
        isBatchable: true,
        abstractType: 'item',
        creationAuthorized: true,
        deletionAuthorized: true,
        duplicateAuthorized: true,
        metaMaskConfigurationAuthorized: [
            'movies',
            'museum',
            'scollection',
            'libris',
            'dam',
            'dam_extern',
            'photo',
            'web',
            'myexpo_museum',
            'archive',
        ],
        treeViewEnable: false,
        favoriteType: 'item',
        category: 'collection',
        types: [],
        availableMenu: [
            {
                value: 'Document',
                translatedKey: 'message.ui.entriesManagementTab.menuTypeDocument',
            },
            {
                value: 'Mask',
                translatedKey: 'message.ui.entriesManagementTab.menuTypeMask',
            },
            {
                value: 'Media',
                translatedKey: 'message.ui.entriesManagementTab.menuTypeMedia',
            },
            {
                value: 'SearchGrid',
                translatedKey: 'message.ui.entriesManagementTab.menuTypeGrid',
            },
            {
                value: 'SubMenuEntry',
                translatedKey: 'message.ui.entriesManagementTab.menuTypeSubMenu',
            },
            {
                value: 'MetaRecord',
                translatedKey: 'message.ui.entriesManagementTab.metaRecord',
            },
            {
                value: 'HierarchicalWithModal',
                translatedKey: 'message.ui.entriesManagementTab.menuTypeHierarchical',
            },
            {
                value: 'RightsContracts',
                translatedKey: 'message.ui.entriesManagementTab.rightsContracts',
            },
            {
                value: 'HistoryList',
                translatedKey: 'message.ui.entriesManagementTab.menuHistoryList',
            },
            {
                value: 'Version',
                translatedKey: 'message.ui.entriesManagementTab.menuVersion',
            },
            {
                value: 'SisterNoticeCard',
                translatedKey: 'message.ui.entriesManagementTab.menuSisterNoticeCard',
            },
            {
                value: 'OtherSetElementCard',
                translatedKey: 'message.ui.entriesManagementTab.menuOtherSetElementCard',
            },
        ],
        linkablePatternType: null,
        availableSavedRequestFields: null,
        workspaceResourcesAuthorizedInGroup: [
            'museum',
            'scollection',
            'photo',
            'myexpo_museum',
            'web',
        ],
        workspaceResourcesAuthorized: [
            'museum',
            'scollection',
            'photo',
            'myexpo_museum',
            'specimen',
        ],
        fieldsForCardConditional: [
            {
                entityFieldId: '5bb1e2e24754f90001cc523b',
                entity: 'numericContainerItem',
                translationKeyName: 'statusesSchema.patrimonialStatus',
                type: 'Boolean',
                thesaurusIdentifier: null,
                isChildren: false,
                isInList: false,
                isList: false,
                id: '5bb1e2e24754f90001cc523b',
            },
            {
                entityFieldId: '5bb1e2e24754f90001cc523a',
                entity: 'numericContainerItem',
                translationKeyName: 'statusesSchema.assignmentStatus',
                type: 'ThesaurusTerm',
                thesaurusIdentifier: 'assignmentStatus',
                isChildren: false,
                isInList: false,
                isList: false,
                id: '5bb1e2e24754f90001cc523a',
            },
            {
                entityFieldId: '5baccdc870aa490001801e0f',
                entity: 'physicalMuseumItem',
                translationKeyName: 'locationItemSchema.department',
                type: 'ThesaurusTerm',
                thesaurusIdentifier: 'departments',
                isChildren: false,
                isInList: false,
                isList: false,
                id: '5baccdc870aa490001801e0f',
            },
            {
                entityFieldId: '5df8e363c2a4ed24197f8e7c',
                entity: 'physicalMuseumItem',
                translationKeyName: 'itemSetSchema.isASet',
                type: 'Boolean',
                thesaurusIdentifier: null,
                isChildren: false,
                isInList: false,
                isList: false,
                id: '5df8e363c2a4ed24197f8e7c',
            },
            {
                entityFieldId: '5b9fb471190494000112fedb',
                entity: 'physicalMuseumManifestation',
                translationKeyName: 'descriptionSchema.domain',
                type: 'ThesaurusTerm',
                thesaurusIdentifier: 'domain',
                isChildren: false,
                isInList: false,
                isList: true,
                id: '5b9fb471190494000112fedb',
            },
            {
                entityFieldId: '5d4c49020de7d241b997e36f',
                entity: 'physicalMuseumManifestation',
                translationKeyName: 'descriptionSchema.denominations.denomination',
                type: 'ThesaurusTerm',
                thesaurusIdentifier: 'denomination',
                isChildren: true,
                isInList: true,
                isList: false,
                id: '5d4c49020de7d241b997e36f',
            },
        ],
        identifierField: '5c50161dca5d4700015b3c92',
        availableReferenceFields: [
            {
                field: '5c9dfb2d69515b0001000b93',
                parent: null,
                referenceField: {
                    entityFieldId: '5c9dfb2d69515b0001000b93',
                    entity: 'physicalMuseumItem',
                    abstractEntity: 'museumItem',
                    schema: 'linkItemSchema',
                    name: 'preEntry',
                    mandatorySystem: false,
                    type: {
                        type: 'PreEntry',
                        subTypes: [],
                        filter: null,
                        isRestrictive: null,
                        esPath: null,
                        trueType: 'PreEntry',
                        useTrueType: false,
                        referenceField: true,
                    },
                    isChildren: false,
                    isInList: false,
                    fieldFormats: [
                        {
                            id: '591ca0a7907aba0001ac69fe',
                            name: 'reference-title',
                            defaultFormat: true,
                        },
                    ],
                    inputComponentResources: [
                        {
                            id: '595ca2a7857aaa0001ac29de',
                            name: 'reference-input-component',
                            defaultComponent: true,
                        },
                    ],
                    entityFields: [],
                    formatters: null,
                    path: 'linkItemSchema.preEntry',
                    pathType:
                        'org.skinsoft.backend.schemas.item.commonsitemschema.linkitemschema.LinkItemSchema|org.skinsoft.backend.types.preentry.PreEntry',
                    isReadOnly: false,
                    isComputed: false,
                    needId: false,
                    readOnlyValues: null,
                    usableForFacets: true,
                    isFieldConditionNumbering: false,
                    _links: {
                        self: {
                            href: 'http://127.0.0.1:8081/entityField/id/5c9dfb2d69515b0001000b93',
                        },
                        entityField: {
                            href: 'http://127.0.0.1:8081/entityField/id/5c9dfb2d69515b0001000b93',
                        },
                    },
                    id: '5c9dfb2d69515b0001000b93',
                },
            },
            {
                field: '5baccdc870aa490001801eb7',
                parent: null,
                referenceField: {
                    entityFieldId: '5baccdc870aa490001801eb7',
                    entity: 'physicalMuseumItem',
                    abstractEntity: 'museumItem',
                    schema: 'linkToManifestation',
                    name: 'referentManifestation',
                    mandatorySystem: false,
                    type: {
                        type: 'PhysicalMuseumManifestation',
                        subTypes: [],
                        filter: null,
                        isRestrictive: null,
                        esPath: null,
                        trueType: 'PhysicalMuseumManifestation',
                        useTrueType: false,
                        referenceField: true,
                    },
                    isChildren: false,
                    isInList: false,
                    fieldFormats: [
                        {
                            id: '591ca0a7907aba0001ac69fe',
                            name: 'reference-title',
                            defaultFormat: true,
                        },
                    ],
                    inputComponentResources: [
                        {
                            id: '595ca2a7857aaa0001ac29de',
                            name: 'reference-input-component',
                            defaultComponent: true,
                        },
                    ],
                    entityFields: [],
                    formatters: null,
                    path: 'linkToManifestation.referentManifestation',
                    pathType:
                        'org.skinsoft.backend.schemas.item.museumitemschema.linktophysicalmuseummanifestationitemschema.LinkToPhysicalMuseumManifestationItemSchema|org.skinsoft.backend.types.manifestation.museummanifestation.physical.PhysicalMuseumManifestation',
                    isReadOnly: false,
                    isComputed: false,
                    needId: false,
                    readOnlyValues: null,
                    usableForFacets: true,
                    isFieldConditionNumbering: false,
                    _links: {
                        self: {
                            href: 'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801eb7',
                        },
                        entityField: {
                            href: 'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801eb7',
                        },
                    },
                    id: '5baccdc870aa490001801eb7',
                },
            },
            {
                field: '5baccdc870aa490001801eb7',
                parent: {
                    field: '5cab47f29c0b15000117943c',
                    parent: null,
                    referenceField: null,
                },
                referenceField: {
                    entityFieldId: '5cab47f29c0b15000117943c',
                    entity: 'physicalMuseumManifestation',
                    abstractEntity: 'museumManifestation',
                    schema: 'linkToExpression',
                    name: 'referentExpression',
                    mandatorySystem: false,
                    type: {
                        type: 'Expression',
                        subTypes: [],
                        filter: null,
                        isRestrictive: null,
                        esPath: null,
                        trueType: 'Expression',
                        useTrueType: false,
                        referenceField: true,
                    },
                    isChildren: false,
                    isInList: false,
                    fieldFormats: [
                        {
                            id: '591ca0a7907aba0001ac69fe',
                            name: 'reference-title',
                            defaultFormat: true,
                        },
                    ],
                    inputComponentResources: [
                        {
                            id: '595ca2a7857aaa0001ac29de',
                            name: 'reference-input-component',
                            defaultComponent: true,
                        },
                    ],
                    entityFields: [],
                    formatters: null,
                    path: 'linkToExpression.referentExpression',
                    pathType:
                        'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.LinkToExpressionManifestationSchema|org.skinsoft.backend.types.expression.Expression',
                    isReadOnly: false,
                    isComputed: false,
                    needId: false,
                    readOnlyValues: null,
                    usableForFacets: true,
                    isFieldConditionNumbering: false,
                    _links: {
                        self: {
                            href: 'http://127.0.0.1:8081/entityField/id/5cab47f29c0b15000117943c',
                        },
                        entityField: {
                            href: 'http://127.0.0.1:8081/entityField/id/5cab47f29c0b15000117943c',
                        },
                    },
                    id: '5cab47f29c0b15000117943c',
                },
            },
            {
                field: '5baccdc870aa490001801eb7',
                parent: {
                    field: '5cab47f29c0b15000117943c',
                    parent: {
                        field: '5ca46879c4147900018e976c',
                        parent: null,
                        referenceField: null,
                    },
                    referenceField: null,
                },
                referenceField: {
                    entityFieldId: '5ca46879c4147900018e976c',
                    entity: 'expression',
                    abstractEntity: null,
                    schema: 'expressionSchema',
                    name: 'referentWork',
                    mandatorySystem: false,
                    type: {
                        type: 'Work',
                        subTypes: ['LiveShowWork', 'MuseumWork', 'FilmWork', 'BiblioWork'],
                        filter: null,
                        isRestrictive: null,
                        esPath: null,
                        trueType: 'Work',
                        useTrueType: false,
                        referenceField: true,
                    },
                    isChildren: false,
                    isInList: false,
                    fieldFormats: [
                        {
                            id: '591ca0a7907aba0001ac69fe',
                            name: 'reference-title',
                            defaultFormat: true,
                        },
                    ],
                    inputComponentResources: [
                        {
                            id: '595ca2a7857aaa0001ac29de',
                            name: 'reference-input-component',
                            defaultComponent: true,
                        },
                    ],
                    entityFields: [],
                    formatters: null,
                    path: 'expressionSchema.referentWork',
                    pathType:
                        'org.skinsoft.backend.schemas.expression.ExpressionSchema|org.skinsoft.backend.types.work.Work',
                    isReadOnly: false,
                    isComputed: false,
                    needId: false,
                    readOnlyValues: null,
                    usableForFacets: true,
                    isFieldConditionNumbering: false,
                    _links: {
                        self: {
                            href: 'http://127.0.0.1:8081/entityField/id/5ca46879c4147900018e976c',
                        },
                        entityField: {
                            href: 'http://127.0.0.1:8081/entityField/id/5ca46879c4147900018e976c',
                        },
                    },
                    id: '5ca46879c4147900018e976c',
                },
            },
            {
                field: '5baccdc870aa490001801e4c',
                parent: null,
                referenceField: {
                    entityFieldId: '5baccdc870aa490001801e4c',
                    entity: 'physicalMuseumItem',
                    abstractEntity: 'museumItem',
                    schema: 'linkItemSchema',
                    name: 'parentItem',
                    mandatorySystem: false,
                    type: {
                        type: 'Item',
                        subTypes: [
                            'NumericBiblioItem',
                            'NumericAccessoryItem',
                            'PhysicalMuseumItem',
                            'NumericMuseumItem',
                            'PhysicalContainerItem',
                            'PhysicalAccessoryItem',
                            'PhysicalBiblioItem',
                            'PhysicalFilmItem',
                            'NumericContainerItem',
                            'NumericFilmItem',
                        ],
                        filter: null,
                        isRestrictive: null,
                        esPath: null,
                        trueType: 'Item',
                        useTrueType: false,
                        referenceField: true,
                    },
                    isChildren: true,
                    isInList: false,
                    fieldFormats: [
                        {
                            id: '591ca0a7907aba0001ac69fe',
                            name: 'reference-title',
                            defaultFormat: true,
                        },
                    ],
                    inputComponentResources: [
                        {
                            id: '595ca2a7857aaa0001ac29de',
                            name: 'reference-input-component',
                            defaultComponent: true,
                        },
                    ],
                    entityFields: [],
                    formatters: null,
                    path: 'linkItemSchema.linkedItem.parentItem',
                    pathType:
                        'org.skinsoft.backend.schemas.item.commonsitemschema.linkitemschema.LinkItemSchema|org.skinsoft.backend.schemas.item.commonsitemschema.linkitemschema.complex.LinkedItem|org.skinsoft.backend.types.item.Item',
                    isReadOnly: false,
                    isComputed: false,
                    needId: false,
                    readOnlyValues: null,
                    usableForFacets: true,
                    isFieldConditionNumbering: false,
                    _links: {
                        self: {
                            href: 'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801e4c',
                        },
                        entityField: {
                            href: 'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801e4c',
                        },
                    },
                    id: '5baccdc870aa490001801e4c',
                },
            },
        ],
        parentPath: 'linkItemSchema.linkedItem.parentItem',
        setVignette: true,
        heritageNumbering: true,
        recordTemplateCreationAuthorized: ['museum', 'scollection', 'myexpo_museum', 'photo'],
        defaultRecordTemplateCreationAuthorized: [
            'museum',
            'scollection',
            'myexpo_museum',
            'photo',
        ],
        indirectReferenceNumbering: [
            'thematicCollection',
            'entry',
            'recolement',
            'conditionReport',
            'acquisitionProject',
            'auditProject',
            'borrowingProject',
            'deviceProject',
            'diffusionProject',
            'enteringDepositProject',
            'expositionProject',
            'fileRetentionProject',
            'loanProject',
            'locationRoomProject',
            'outgoingDepositProject',
            'outProject',
            'programmingProject',
            'restorationProject',
            'transcodingProject',
        ],
        usedInFederatedSearch: true,
        formatterAuthorized: true,
        setPath: 'itemSetSchema.setItem',
        _links: {
            self: {
                href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba0001ac6442',
            },
            entity: {
                href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba0001ac6442',
            },
        },
        id: '595ca6a7857aba0001ac6442',
    },
    entities: [
        {
            entityName: 'expression',
            isBatchable: true,
            abstractType: null,
            creationAuthorized: true,
            deletionAuthorized: true,
            duplicateAuthorized: true,
            metaMaskConfigurationAuthorized: ['movies', 'libris', 'photo', 'web', 'archive'],
            treeViewEnable: false,
            favoriteType: null,
            category: 'collection',
            types: [],
            availableMenu: [
                {
                    value: 'Document',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeDocument',
                },
                {
                    value: 'Mask',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMask',
                },
                {
                    value: 'MetaRecord',
                    translatedKey: 'message.ui.entriesManagementTab.metaRecord',
                },
                {
                    value: 'Media',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMedia',
                },
                {
                    value: 'SearchGrid',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeGrid',
                },
                {
                    value: 'SubMenuEntry',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeSubMenu',
                },
                {
                    value: 'HistoryList',
                    translatedKey: 'message.ui.entriesManagementTab.menuHistoryList',
                },
            ],
            linkablePatternType: null,
            availableSavedRequestFields: null,
            workspaceResourcesAuthorizedInGroup: [
                'movies',
                'museum',
                'libris',
                'scollection',
                'dam',
                'dam_extern',
                'photo',
                'myexpo_museum',
                'web',
                'specimen',
            ],
            workspaceResourcesAuthorized: [
                'movies',
                'museum',
                'libris',
                'scollection',
                'dam',
                'dam_extern',
                'photo',
                'myexpo_museum',
                'specimen',
            ],
            fieldsForCardConditional: [
                {
                    entityFieldId: '5ca46879c4147900018e973f',
                    entity: 'expression',
                    translationKeyName: 'expressionSchema.forms',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'expressionForm',
                    isChildren: false,
                    isInList: false,
                    isList: true,
                    id: '5ca46879c4147900018e973f',
                },
            ],
            identifierField: '5ca46879c4147900018e9732',
            availableReferenceFields: [
                {
                    field: '5ca46879c4147900018e976c',
                    parent: null,
                    referenceField: {
                        entityFieldId: '5ca46879c4147900018e976c',
                        entity: 'expression',
                        abstractEntity: null,
                        schema: 'expressionSchema',
                        name: 'referentWork',
                        mandatorySystem: false,
                        type: {
                            type: 'Work',
                            subTypes: ['LiveShowWork', 'MuseumWork', 'FilmWork', 'BiblioWork'],
                            filter: null,
                            isRestrictive: null,
                            esPath: null,
                            trueType: 'Work',
                            useTrueType: false,
                            referenceField: true,
                        },
                        isChildren: false,
                        isInList: false,
                        fieldFormats: [
                            {
                                id: '591ca0a7907aba0001ac69fe',
                                name: 'reference-title',
                                defaultFormat: true,
                            },
                        ],
                        inputComponentResources: [
                            {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                        ],
                        entityFields: [],
                        formatters: null,
                        path: 'expressionSchema.referentWork',
                        pathType:
                            'org.skinsoft.backend.schemas.expression.ExpressionSchema|org.skinsoft.backend.types.work.Work',
                        isReadOnly: false,
                        isComputed: false,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        _links: {
                            self: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5ca46879c4147900018e976c',
                            },
                            entityField: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5ca46879c4147900018e976c',
                            },
                        },
                        id: '5ca46879c4147900018e976c',
                    },
                },
            ],
            parentPath: null,
            setVignette: true,
            heritageNumbering: null,
            recordTemplateCreationAuthorized: [],
            defaultRecordTemplateCreationAuthorized: [],
            indirectReferenceNumbering: null,
            usedInFederatedSearch: false,
            formatterAuthorized: true,
            setPath: null,
            _links: {
                self: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba085137987e',
                },
                entity: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba085137987e',
                },
            },
            id: '595ca6a7857aba085137987e',
        },
        {
            entityName: 'physicalMuseumManifestation',
            isBatchable: true,
            abstractType: 'manifestation',
            creationAuthorized: false,
            deletionAuthorized: true,
            duplicateAuthorized: true,
            metaMaskConfigurationAuthorized: [
                'movies',
                'libris',
                'dam',
                'dam_extern',
                'photo',
                'web',
                'archive',
            ],
            treeViewEnable: false,
            favoriteType: null,
            category: 'collection',
            types: [],
            availableMenu: [
                {
                    value: 'Document',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeDocument',
                },
                {
                    value: 'Mask',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMask',
                },
                {
                    value: 'Media',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMedia',
                },
                {
                    value: 'SearchGrid',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeGrid',
                },
                {
                    value: 'SubMenuEntry',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeSubMenu',
                },
                {
                    value: 'HistoryList',
                    translatedKey: 'message.ui.entriesManagementTab.menuHistoryList',
                },
            ],
            linkablePatternType: null,
            availableSavedRequestFields: null,
            workspaceResourcesAuthorizedInGroup: [
                'museum',
                'scollection',
                'photo',
                'myexpo_museum',
                'web',
            ],
            workspaceResourcesAuthorized: ['museum', 'scollection', 'myexpo_museum', 'specimen'],
            fieldsForCardConditional: [
                {
                    entityFieldId: '5b9fb471190494000112ff03',
                    entity: 'physicalMuseumManifestation',
                    translationKeyName: 'descriptionSchema.typeOfNumeric',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'typeOfNumeric',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5b9fb471190494000112ff03',
                },
                {
                    entityFieldId: '5b9fb471190494000112ff02',
                    entity: 'physicalMuseumManifestation',
                    translationKeyName: 'descriptionSchema.typeOfPhysical',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'typeOfPhysical',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5b9fb471190494000112ff02',
                },
                {
                    entityFieldId: '5b9fb471190494000112fedb',
                    entity: 'physicalMuseumManifestation',
                    translationKeyName: 'descriptionSchema.domain',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'domain',
                    isChildren: false,
                    isInList: false,
                    isList: true,
                    id: '5b9fb471190494000112fedb',
                },
                {
                    entityFieldId: '5d4c49020de7d241b997e36f',
                    entity: 'physicalMuseumManifestation',
                    translationKeyName: 'descriptionSchema.denominations.denomination',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'denomination',
                    isChildren: true,
                    isInList: true,
                    isList: false,
                    id: '5d4c49020de7d241b997e36f',
                },
            ],
            identifierField: '5b9fb471190494000112feda',
            availableReferenceFields: null,
            parentPath: null,
            setVignette: true,
            heritageNumbering: null,
            recordTemplateCreationAuthorized: [],
            defaultRecordTemplateCreationAuthorized: [],
            indirectReferenceNumbering: null,
            usedInFederatedSearch: false,
            formatterAuthorized: true,
            setPath: null,
            _links: {
                self: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca695cd523a0001ac947e',
                },
                entity: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca695cd523a0001ac947e',
                },
            },
            id: '595ca695cd523a0001ac947e',
        },
        {
            entityName: 'physicalMuseumItem',
            isBatchable: true,
            abstractType: 'item',
            creationAuthorized: true,
            deletionAuthorized: true,
            duplicateAuthorized: true,
            metaMaskConfigurationAuthorized: [
                'movies',
                'museum',
                'scollection',
                'libris',
                'dam',
                'dam_extern',
                'photo',
                'web',
                'myexpo_museum',
                'archive',
            ],
            treeViewEnable: false,
            favoriteType: 'item',
            category: 'collection',
            types: [],
            availableMenu: [
                {
                    value: 'Document',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeDocument',
                },
                {
                    value: 'Mask',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMask',
                },
                {
                    value: 'Media',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMedia',
                },
                {
                    value: 'SearchGrid',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeGrid',
                },
                {
                    value: 'SubMenuEntry',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeSubMenu',
                },
                {
                    value: 'MetaRecord',
                    translatedKey: 'message.ui.entriesManagementTab.metaRecord',
                },
                {
                    value: 'HierarchicalWithModal',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeHierarchical',
                },
                {
                    value: 'RightsContracts',
                    translatedKey: 'message.ui.entriesManagementTab.rightsContracts',
                },
                {
                    value: 'HistoryList',
                    translatedKey: 'message.ui.entriesManagementTab.menuHistoryList',
                },
                {
                    value: 'Version',
                    translatedKey: 'message.ui.entriesManagementTab.menuVersion',
                },
                {
                    value: 'SisterNoticeCard',
                    translatedKey: 'message.ui.entriesManagementTab.menuSisterNoticeCard',
                },
                {
                    value: 'OtherSetElementCard',
                    translatedKey: 'message.ui.entriesManagementTab.menuOtherSetElementCard',
                },
            ],
            linkablePatternType: null,
            availableSavedRequestFields: null,
            workspaceResourcesAuthorizedInGroup: [
                'museum',
                'scollection',
                'photo',
                'myexpo_museum',
                'web',
            ],
            workspaceResourcesAuthorized: [
                'museum',
                'scollection',
                'photo',
                'myexpo_museum',
                'specimen',
            ],
            fieldsForCardConditional: [
                {
                    entityFieldId: '5bb1e2e24754f90001cc523b',
                    entity: 'numericContainerItem',
                    translationKeyName: 'statusesSchema.patrimonialStatus',
                    type: 'Boolean',
                    thesaurusIdentifier: null,
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5bb1e2e24754f90001cc523b',
                },
                {
                    entityFieldId: '5bb1e2e24754f90001cc523a',
                    entity: 'numericContainerItem',
                    translationKeyName: 'statusesSchema.assignmentStatus',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'assignmentStatus',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5bb1e2e24754f90001cc523a',
                },
                {
                    entityFieldId: '5baccdc870aa490001801e0f',
                    entity: 'physicalMuseumItem',
                    translationKeyName: 'locationItemSchema.department',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'departments',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5baccdc870aa490001801e0f',
                },
                {
                    entityFieldId: '5df8e363c2a4ed24197f8e7c',
                    entity: 'physicalMuseumItem',
                    translationKeyName: 'itemSetSchema.isASet',
                    type: 'Boolean',
                    thesaurusIdentifier: null,
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5df8e363c2a4ed24197f8e7c',
                },
                {
                    entityFieldId: '5b9fb471190494000112fedb',
                    entity: 'physicalMuseumManifestation',
                    translationKeyName: 'descriptionSchema.domain',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'domain',
                    isChildren: false,
                    isInList: false,
                    isList: true,
                    id: '5b9fb471190494000112fedb',
                },
                {
                    entityFieldId: '5d4c49020de7d241b997e36f',
                    entity: 'physicalMuseumManifestation',
                    translationKeyName: 'descriptionSchema.denominations.denomination',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'denomination',
                    isChildren: true,
                    isInList: true,
                    isList: false,
                    id: '5d4c49020de7d241b997e36f',
                },
            ],
            identifierField: '5c50161dca5d4700015b3c92',
            availableReferenceFields: [
                {
                    field: '5c9dfb2d69515b0001000b93',
                    parent: null,
                    referenceField: {
                        entityFieldId: '5c9dfb2d69515b0001000b93',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'linkItemSchema',
                        name: 'preEntry',
                        mandatorySystem: false,
                        type: {
                            type: 'PreEntry',
                            subTypes: [],
                            filter: null,
                            isRestrictive: null,
                            esPath: null,
                            trueType: 'PreEntry',
                            useTrueType: false,
                            referenceField: true,
                        },
                        isChildren: false,
                        isInList: false,
                        fieldFormats: [
                            {
                                id: '591ca0a7907aba0001ac69fe',
                                name: 'reference-title',
                                defaultFormat: true,
                            },
                        ],
                        inputComponentResources: [
                            {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                        ],
                        entityFields: [],
                        formatters: null,
                        path: 'linkItemSchema.preEntry',
                        pathType:
                            'org.skinsoft.backend.schemas.item.commonsitemschema.linkitemschema.LinkItemSchema|org.skinsoft.backend.types.preentry.PreEntry',
                        isReadOnly: false,
                        isComputed: false,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        _links: {
                            self: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5c9dfb2d69515b0001000b93',
                            },
                            entityField: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5c9dfb2d69515b0001000b93',
                            },
                        },
                        id: '5c9dfb2d69515b0001000b93',
                    },
                },
                {
                    field: '5baccdc870aa490001801eb7',
                    parent: null,
                    referenceField: {
                        entityFieldId: '5baccdc870aa490001801eb7',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'linkToManifestation',
                        name: 'referentManifestation',
                        mandatorySystem: false,
                        type: {
                            type: 'PhysicalMuseumManifestation',
                            subTypes: [],
                            filter: null,
                            isRestrictive: null,
                            esPath: null,
                            trueType: 'PhysicalMuseumManifestation',
                            useTrueType: false,
                            referenceField: true,
                        },
                        isChildren: false,
                        isInList: false,
                        fieldFormats: [
                            {
                                id: '591ca0a7907aba0001ac69fe',
                                name: 'reference-title',
                                defaultFormat: true,
                            },
                        ],
                        inputComponentResources: [
                            {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                        ],
                        entityFields: [],
                        formatters: null,
                        path: 'linkToManifestation.referentManifestation',
                        pathType:
                            'org.skinsoft.backend.schemas.item.museumitemschema.linktophysicalmuseummanifestationitemschema.LinkToPhysicalMuseumManifestationItemSchema|org.skinsoft.backend.types.manifestation.museummanifestation.physical.PhysicalMuseumManifestation',
                        isReadOnly: false,
                        isComputed: false,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        _links: {
                            self: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801eb7',
                            },
                            entityField: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801eb7',
                            },
                        },
                        id: '5baccdc870aa490001801eb7',
                    },
                },
                {
                    field: '5baccdc870aa490001801eb7',
                    parent: {
                        field: '5cab47f29c0b15000117943c',
                        parent: null,
                        referenceField: null,
                    },
                    referenceField: {
                        entityFieldId: '5cab47f29c0b15000117943c',
                        entity: 'physicalMuseumManifestation',
                        abstractEntity: 'museumManifestation',
                        schema: 'linkToExpression',
                        name: 'referentExpression',
                        mandatorySystem: false,
                        type: {
                            type: 'Expression',
                            subTypes: [],
                            filter: null,
                            isRestrictive: null,
                            esPath: null,
                            trueType: 'Expression',
                            useTrueType: false,
                            referenceField: true,
                        },
                        isChildren: false,
                        isInList: false,
                        fieldFormats: [
                            {
                                id: '591ca0a7907aba0001ac69fe',
                                name: 'reference-title',
                                defaultFormat: true,
                            },
                        ],
                        inputComponentResources: [
                            {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                        ],
                        entityFields: [],
                        formatters: null,
                        path: 'linkToExpression.referentExpression',
                        pathType:
                            'org.skinsoft.backend.schemas.manifestation.commonmanifestationschema.LinkToExpressionManifestationSchema|org.skinsoft.backend.types.expression.Expression',
                        isReadOnly: false,
                        isComputed: false,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        _links: {
                            self: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5cab47f29c0b15000117943c',
                            },
                            entityField: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5cab47f29c0b15000117943c',
                            },
                        },
                        id: '5cab47f29c0b15000117943c',
                    },
                },
                {
                    field: '5baccdc870aa490001801eb7',
                    parent: {
                        field: '5cab47f29c0b15000117943c',
                        parent: {
                            field: '5ca46879c4147900018e976c',
                            parent: null,
                            referenceField: null,
                        },
                        referenceField: null,
                    },
                    referenceField: {
                        entityFieldId: '5ca46879c4147900018e976c',
                        entity: 'expression',
                        abstractEntity: null,
                        schema: 'expressionSchema',
                        name: 'referentWork',
                        mandatorySystem: false,
                        type: {
                            type: 'Work',
                            subTypes: ['LiveShowWork', 'MuseumWork', 'FilmWork', 'BiblioWork'],
                            filter: null,
                            isRestrictive: null,
                            esPath: null,
                            trueType: 'Work',
                            useTrueType: false,
                            referenceField: true,
                        },
                        isChildren: false,
                        isInList: false,
                        fieldFormats: [
                            {
                                id: '591ca0a7907aba0001ac69fe',
                                name: 'reference-title',
                                defaultFormat: true,
                            },
                        ],
                        inputComponentResources: [
                            {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                        ],
                        entityFields: [],
                        formatters: null,
                        path: 'expressionSchema.referentWork',
                        pathType:
                            'org.skinsoft.backend.schemas.expression.ExpressionSchema|org.skinsoft.backend.types.work.Work',
                        isReadOnly: false,
                        isComputed: false,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        _links: {
                            self: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5ca46879c4147900018e976c',
                            },
                            entityField: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5ca46879c4147900018e976c',
                            },
                        },
                        id: '5ca46879c4147900018e976c',
                    },
                },
                {
                    field: '5baccdc870aa490001801e4c',
                    parent: null,
                    referenceField: {
                        entityFieldId: '5baccdc870aa490001801e4c',
                        entity: 'physicalMuseumItem',
                        abstractEntity: 'museumItem',
                        schema: 'linkItemSchema',
                        name: 'parentItem',
                        mandatorySystem: false,
                        type: {
                            type: 'Item',
                            subTypes: [
                                'NumericBiblioItem',
                                'NumericAccessoryItem',
                                'PhysicalMuseumItem',
                                'NumericMuseumItem',
                                'PhysicalContainerItem',
                                'PhysicalAccessoryItem',
                                'PhysicalBiblioItem',
                                'PhysicalFilmItem',
                                'NumericContainerItem',
                                'NumericFilmItem',
                            ],
                            filter: null,
                            isRestrictive: null,
                            esPath: null,
                            trueType: 'Item',
                            useTrueType: false,
                            referenceField: true,
                        },
                        isChildren: true,
                        isInList: false,
                        fieldFormats: [
                            {
                                id: '591ca0a7907aba0001ac69fe',
                                name: 'reference-title',
                                defaultFormat: true,
                            },
                        ],
                        inputComponentResources: [
                            {
                                id: '595ca2a7857aaa0001ac29de',
                                name: 'reference-input-component',
                                defaultComponent: true,
                            },
                        ],
                        entityFields: [],
                        formatters: null,
                        path: 'linkItemSchema.linkedItem.parentItem',
                        pathType:
                            'org.skinsoft.backend.schemas.item.commonsitemschema.linkitemschema.LinkItemSchema|org.skinsoft.backend.schemas.item.commonsitemschema.linkitemschema.complex.LinkedItem|org.skinsoft.backend.types.item.Item',
                        isReadOnly: false,
                        isComputed: false,
                        needId: false,
                        readOnlyValues: null,
                        usableForFacets: true,
                        isFieldConditionNumbering: false,
                        _links: {
                            self: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801e4c',
                            },
                            entityField: {
                                href:
                                    'http://127.0.0.1:8081/entityField/id/5baccdc870aa490001801e4c',
                            },
                        },
                        id: '5baccdc870aa490001801e4c',
                    },
                },
            ],
            parentPath: 'linkItemSchema.linkedItem.parentItem',
            setVignette: true,
            heritageNumbering: true,
            recordTemplateCreationAuthorized: ['museum', 'scollection', 'myexpo_museum', 'photo'],
            defaultRecordTemplateCreationAuthorized: [
                'museum',
                'scollection',
                'myexpo_museum',
                'photo',
            ],
            indirectReferenceNumbering: [
                'thematicCollection',
                'entry',
                'recolement',
                'conditionReport',
                'acquisitionProject',
                'auditProject',
                'borrowingProject',
                'deviceProject',
                'diffusionProject',
                'enteringDepositProject',
                'expositionProject',
                'fileRetentionProject',
                'loanProject',
                'locationRoomProject',
                'outgoingDepositProject',
                'outProject',
                'programmingProject',
                'restorationProject',
                'transcodingProject',
            ],
            usedInFederatedSearch: true,
            formatterAuthorized: true,
            setPath: 'itemSetSchema.setItem',
            _links: {
                self: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba0001ac6442',
                },
                entity: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba0001ac6442',
                },
            },
            id: '595ca6a7857aba0001ac6442',
        },
        {
            entityName: 'museumWork',
            isBatchable: true,
            abstractType: 'work',
            creationAuthorized: true,
            deletionAuthorized: true,
            duplicateAuthorized: true,
            metaMaskConfigurationAuthorized: null,
            treeViewEnable: false,
            favoriteType: 'work',
            category: 'collection',
            types: [],
            availableMenu: [
                {
                    value: 'Document',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeDocument',
                },
                {
                    value: 'Mask',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMask',
                },
                {
                    value: 'Media',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeMedia',
                },
                {
                    value: 'SearchGrid',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeGrid',
                },
                {
                    value: 'SubMenuEntry',
                    translatedKey: 'message.ui.entriesManagementTab.menuTypeSubMenu',
                },
                {
                    value: 'WorkItems',
                    translatedKey: 'message.ui.entriesManagementTab.workItems',
                },
                {
                    value: 'HistoryList',
                    translatedKey: 'message.ui.entriesManagementTab.menuHistoryList',
                },
                {
                    value: 'WorkManifestations',
                    translatedKey: 'message.ui.entriesManagementTab.workManifestations',
                },
            ],
            linkablePatternType: null,
            availableSavedRequestFields: null,
            workspaceResourcesAuthorizedInGroup: [
                'museum',
                'scollection',
                'photo',
                'web',
                'myexpo_museum',
            ],
            workspaceResourcesAuthorized: [
                'museum',
                'scollection',
                'photo',
                'myexpo_museum',
                'specimen',
            ],
            fieldsForCardConditional: [
                {
                    entityFieldId: '5b9fb469190494000112cffd',
                    entity: 'museumWork',
                    translationKeyName: 'identificationWorkSchema.workType',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'typeOfWork',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5b9fb469190494000112cffd',
                },
                {
                    entityFieldId: '5b9fb469190494000112cffc',
                    entity: 'museumWork',
                    translationKeyName: 'identificationWorkSchema.workStatus',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'workStatus',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5b9fb469190494000112cffc',
                },
                {
                    entityFieldId: '5b9fb469190494000112cffe',
                    entity: 'museumWork',
                    translationKeyName: 'identificationWorkSchema.variantType',
                    type: 'ThesaurusTerm',
                    thesaurusIdentifier: 'variantType',
                    isChildren: false,
                    isInList: false,
                    isList: false,
                    id: '5b9fb469190494000112cffe',
                },
            ],
            identifierField: '5c50161fca5d4700015b3ca2',
            availableReferenceFields: null,
            parentPath: null,
            setVignette: true,
            heritageNumbering: null,
            recordTemplateCreationAuthorized: ['photo'],
            defaultRecordTemplateCreationAuthorized: ['photo'],
            indirectReferenceNumbering: null,
            usedInFederatedSearch: false,
            formatterAuthorized: true,
            setPath: null,
            _links: {
                self: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba0851ac987e',
                },
                entity: {
                    href: 'http://127.0.0.1:8081/entity/entity/595ca6a7857aba0851ac987e',
                },
            },
            id: '595ca6a7857aba0851ac987e',
        },
    ],
    workspaceCreation: '5d6917c3fb6ee95ed082f268',
    workspaceSharing: [],
    _links: {
        self: {
            href: 'http://127.0.0.1:8081/meta-record-masks/6232e1862649006b314bd78e',
        },
        'meta-record-masks': {
            href: 'http://127.0.0.1:8081/meta-record-masks/6232e1862649006b314bd78e',
        },
    },
    id: '6232e1862649006b314bd78e',
}
